export const BILLS_FILTER_KEY_SEARCH = 'searchString';
export const BILLS_FILTER_KEY_BILLING_PERIOD = 'billingPeriod';
export const BILLS_FILTER_KEY_STATUS = 'status';
export const BILLS_FILTER_KEY_PROJECT = 'project';
export const BILLS_FILTER_KEY_MEMBER = 'member';

export const BILLS_TABLE_FILTER_KEYS = [
  BILLS_FILTER_KEY_SEARCH,
  BILLS_FILTER_KEY_BILLING_PERIOD,
  BILLS_FILTER_KEY_STATUS,
  BILLS_FILTER_KEY_PROJECT,
  BILLS_FILTER_KEY_MEMBER,
];

export const BILLS_TABLE_FILTERS_STORAGE_KEY = 'bills-table-filters';

// Separate storage key for the generate-bills screen so its filters never share
// localStorage with the bills list page (which would otherwise leak filters
// across the two screens).
export const GENERATE_BILLS_TABLE_FILTERS_STORAGE_KEY = 'generate-bills-table-filters';
